export enum ContractRestructuringActionType {
  OUTSTANDING_REPURCHASE = 'outstanding_repurchase',
}
